import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import ReactComponentView from 'views/main/react/ReactComponentView';
import templateHtml from 'templates/main/Modal/ReactModalPopupView.html';

export default Backbone.View.extend({
    template: _.template(templateHtml),

    initialize: function(args) {
        this.reactComponent = args.reactComponent;
        if (!this.reactComponent) {
            throw Error('reactComponent is required!');
        }

        this.additionalClasses = args.additionalClasses || '';

        this.args = args;
    },

    render: function() {
        this.$el.html(
            this.template({
                additionalClasses: this.additionalClasses
            })
        );

        this.r = new ReactComponentView();
        this.r.renderComponent(this.reactComponent, this.$('.react-placeholder')[0], this.args.props);

        return this;
    },

    destroy: function() {
        if (this.r) {
            this.r.removeComponent();
        }
    }
});
